const costCenters = {
    firestorePath: '/costCenters',
    firestoreRefType: 'collection',
    moduleName: 'costCenters',
    statePropName: 'costCenters',
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: '%convertTimestamp%', // default
            updated_at: '%convertTimestamp%', // default
        },
    },
    state: {
        costCenters: [],
    },
    getters: {
        getCostCenters: (state) => {
            return _.sortBy(_.toArray(state.costCenters), costCenter => (costCenter.name || '').toLowerCase());
        },
    },
    mutations: {

    },
    actions: {},
}

export default costCenters
